package link.erpango.quip.catalog.sections

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material.Icon
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.Clear
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Share
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.filled.ThumbUp
import androidx.compose.material.icons.filled.Warning
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.theme.QuipDimens
import link.erpango.quip.ui.components.QuipCard
import link.erpango.quip.ui.components.QuipSectionHeader

private data class IconEntry(val name: String, val icon: ImageVector)

private val materialIcons = listOf(
    IconEntry("ArrowBack", Icons.Default.ArrowBack),
    IconEntry("Settings", Icons.Default.Settings),
    IconEntry("Share", Icons.Default.Share),
    IconEntry("Build", Icons.Default.Build),
    IconEntry("Add", Icons.Default.Add),
    IconEntry("Clear", Icons.Default.Clear),
    IconEntry("Warning", Icons.Default.Warning),
    IconEntry("Info", Icons.Default.Info),
    IconEntry("Star", Icons.Default.Star),
    IconEntry("Person", Icons.Default.Person),
    IconEntry("Home", Icons.Default.Home),
    IconEntry("Search", Icons.Default.Search),
    IconEntry("Edit", Icons.Default.Edit),
    IconEntry("Delete", Icons.Default.Delete),
    IconEntry("Favorite", Icons.Default.Favorite),
    IconEntry("ThumbUp", Icons.Default.ThumbUp),
    IconEntry("Notifications", Icons.Default.Notifications),
    IconEntry("ArrowDropDown", Icons.Default.ArrowDropDown),
    IconEntry("KBArrowDown", Icons.Default.KeyboardArrowDown),
    IconEntry("KBArrowUp", Icons.Default.KeyboardArrowUp),
)

private const val COLUMNS = 4

@Composable
fun CatalogIconsSection() {
    LazyColumn(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = QuipDimens.padding16, vertical = QuipDimens.padding12),
        verticalArrangement = Arrangement.spacedBy(QuipDimens.padding20),
    ) {
        item {
            QuipSectionHeader(title = "Material Icons (usados en la app)")
            Spacer(Modifier.height(QuipDimens.padding8))
        }

        val rows = materialIcons.chunked(COLUMNS)
        items(rows.size) { rowIndex ->
            QuipCard {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceEvenly,
                ) {
                    val rowIcons = rows[rowIndex]
                    repeat(COLUMNS) { col ->
                        val entry = rowIcons.getOrNull(col)
                        if (entry != null) {
                            IconCell(entry = entry, modifier = Modifier.weight(1f))
                        } else {
                            Spacer(Modifier.weight(1f))
                        }
                    }
                }
            }
        }

        item {
            Spacer(Modifier.height(QuipDimens.padding12))
            QuipSectionHeader(title = "Nota sobre FontAwesome")
            Spacer(Modifier.height(QuipDimens.padding8))
            QuipCard {
                Text(
                    text = "La app incluye compose.material.icons.extended y Font Awesome Icons. " +
                        "Para vehículos se usan FontAwesomeIcons.Solid.Car, Motorcycle, Truck, Bus, " +
                        "ShuttleVan y QuestionCircle (importados desde compose.materialIconsExtended). " +
                        "Añadir aquí nuevos iconos a medida que se incorporen al proyecto.",
                    style = MaterialTheme.typography.body2,
                    color = QuipColors.colorTextSecondary,
                )
            }
        }

        item { Spacer(Modifier.height(QuipDimens.padding24)) }
    }
}

@Composable
private fun IconCell(entry: IconEntry, modifier: Modifier = Modifier) {
    Column(
        modifier = modifier.padding(vertical = QuipDimens.padding8),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        Icon(
            imageVector = entry.icon,
            contentDescription = entry.name,
            tint = QuipColors.colorPrimary,
            modifier = Modifier.size(QuipDimens.iconSize28),
        )
        Spacer(Modifier.height(4.dp))
        Text(
            text = entry.name,
            style = MaterialTheme.typography.caption,
            color = QuipColors.colorTextSecondary,
            fontSize = 9.sp,
            maxLines = 1,
        )
    }
}
